import ImageSlider from "../components/Sliders/ImageSlider";
import { HomeCommunityCover } from "../assets/data/Imagedata";
import LineofEngagement from "../components/LineofEngagement";
import { CSDLogoAbout } from "../assets/data/Imagedata";
import LogoLoader from "../components/LogoLoader";
import LogoPortfolioSlider from "../components/Sliders/LogoPortfolioSlider";
import Testimonials from "../components/Tools/Testimonials";
import UpComingEvents from "../components/UpComingEvents";
import {
  FaPhone,
  FaTrophy,
  FaGavel,
  FaClock,
  FaCheckSquare,
  FaChartLine,
} from "react-icons/fa";
import { MdArrowOutward } from "react-icons/md";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const HomeTitle = () => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 1000);

    return () => clearTimeout(timer);
  }, []);

  if (loading) {
    return <LogoLoader isLoading={loading} />;
  }

  return (
    <section className="relative">
      {/* Top Banner */}
      <div className="bg-white text-center py-3 text-[12px] sm:text-base border-b border-gray-200 ">
        Consumer Rights Council ||{" "}
        <span className="font-bold text-blue-900">उपभोक्ता अधिकार परिषद्</span>
      </div>

      {/* Hero Sections with Floating Stats */}
      <div className="relative">
        <ImageSlider />

        <div className="w-full flex justify-center px-2 sm:px-4 -mt-4 sm:-mt-12 relative z-20">
          <div className="w-full max-w-5xl">
            {/* ALWAYS 3 GRID */}
            <div className="grid grid-cols-3 gap-2 sm:gap-6">
              {/* Box 1 */}
              <div className="bg-white rounded-xl sm:rounded-2xl p-3 sm:p-5 flex flex-col sm:flex-row items-center justify-center gap-2 sm:gap-4 text-center sm:text-left shadow-[0_8px_30px_rgb(0,0,0,0.08)] border border-gray-100 hover:-translate-y-1 hover:shadow-[0_8px_30px_rgb(0,0,0,0.16)] transition-all duration-300 group">
                <div className="p-2.5 sm:p-3.5 bg-gradient-to-br from-blue-50 to-blue-100/50 rounded-xl sm:rounded-2xl group-hover:scale-110 group-hover:rotate-3 transition-transform duration-300">
                  <FaTrophy className="text-lg sm:text-2xl text-blue-600 drop-shadow-sm" />
                </div>
                <div>
                  <span className="block text-[16px] sm:text-[20px] font-extrabold text-gray-800 tracking-tight group-hover:text-blue-600 transition-colors duration-300">
                    400+
                  </span>
                  <p className="text-[10px] sm:text-[14px] font-bold text-gray-500 uppercase tracking-wider mt-0.5 sm:mt-1">
                    Cases Filed
                  </p>
                </div>
              </div>

              {/* Box 2 */}
              <div className="bg-white rounded-xl sm:rounded-2xl p-3 sm:p-5 flex flex-col sm:flex-row items-center justify-center gap-2 sm:gap-4 text-center sm:text-left shadow-[0_8px_30px_rgb(0,0,0,0.08)] border border-gray-100 hover:-translate-y-1 hover:shadow-[0_8px_30px_rgb(0,0,0,0.16)] transition-all duration-300 group">
                <div className="p-2.5 sm:p-3.5 bg-gradient-to-br from-red-50 to-red-100/50 rounded-xl sm:rounded-2xl group-hover:scale-110 group-hover:-rotate-3 transition-transform duration-300">
                  <FaGavel className="text-lg sm:text-2xl text-red-500 drop-shadow-sm" />
                </div>
                <div>
                  <span className="block text-[16px] sm:text-[20px] font-extrabold text-gray-800 tracking-tight group-hover:text-red-500 transition-colors duration-300">
                    1600+
                  </span>
                  <p className="text-[10px] sm:text-[14px] font-bold text-gray-500 uppercase tracking-wider mt-0.5 sm:mt-1">
                    Awareness Camps
                  </p>
                </div>
              </div>

              {/* Box 3 */}
              <div className="bg-white rounded-xl sm:rounded-2xl p-3 sm:p-5 flex flex-col sm:flex-row items-center justify-center gap-2 sm:gap-4 text-center sm:text-left shadow-[0_8px_30px_rgb(0,0,0,0.08)] border border-gray-100 hover:-translate-y-1 hover:shadow-[0_8px_30px_rgb(0,0,0,0.16)] transition-all duration-300 group">
                <div className="p-2.5 sm:p-3.5 bg-gradient-to-br from-emerald-50 to-emerald-100/50 rounded-xl sm:rounded-2xl group-hover:scale-110 group-hover:rotate-3 transition-transform duration-300">
                  <FaClock className="text-lg sm:text-2xl text-emerald-500 drop-shadow-sm" />
                </div>
                <div>
                  <span className="block text-[16px] sm:text-[20px] font-extrabold text-gray-800 tracking-tight group-hover:text-emerald-500 transition-colors duration-300">
                    30+
                  </span>
                  <p className="text-[10px] sm:text-[14px] font-bold text-gray-500 uppercase tracking-wider mt-0.5 sm:mt-1">
                    Training Sessions
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <LogoPortfolioSlider />
      <UpComingEvents />

      {/* Welcome Section with Hero Background */}
      <section className="relative bg-gradient-to-br from-blue-900 via-blue-800 to-blue-950 rounded-2xl overflow-hidden mb-16 sm:mb-20 shadow-2xl">
        {/* Hero Background Pattern */}
        <div className="absolute inset-0">
          {/* Dark overlay for better text contrast */}
          <div className="absolute inset-0 bg-gradient-to-br from-black/20 via-blue-900/30 to-black/20"></div>

          {/* Pattern overlay */}
          <div
            className="absolute inset-0 opacity-20"
            style={{
              backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.2'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
              backgroundSize: "60px 60px",
            }}
          ></div>

          {/* Blue gradient overlay */}
          <div className="absolute inset-0 bg-gradient-to-br from-blue-600/10 via-transparent to-orange-500/10"></div>
        </div>

        {/* Content Container */}
        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 sm:py-20 lg:py-24">
          {/* Hero Title */}
          <div className="text-center mb-12 sm:mb-16">
            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold mb-4 text-white tracking-tight">
              <span className="bg-gradient-to-r from-white via-blue-100 to-white bg-clip-text text-transparent">
                Welcome to CRC
              </span>
            </h1>
            <p className="text-xl sm:text-2xl text-blue-100 max-w-3xl mx-auto font-medium">
              Where consumer rights meet impactful action
            </p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center">
            {/* Left: Logo Text with Hero Styling */}
            <div className="flex flex-col items-center lg:items-start text-center lg:text-left space-y-6 lg:space-y-8">
              <div className="relative">
                {/* Glowing effect behind text */}
                <div className="absolute -inset-4 bg-gradient-to-r from-orange-500/20 to-blue-500/20 blur-2xl rounded-3xl opacity-50"></div>

                <div className="space-y-4 lg:space-y-6 relative z-10">
                  <p className="text-2xl sm:text-3xl lg:text-4xl font-semibold text-white tracking-tight">
                    India's Premier
                  </p>

                  <div className="relative inline-block">
                    <span className="relative z-10 text-orange-400 font-bold text-3xl sm:text-4xl lg:text-5xl block px-6 py-3 bg-white/10 backdrop-blur-sm rounded-xl border border-white/20">
                      Volunteer Consumer Organization
                    </span>
                    {/* Shimmer effect */}
                    <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/10 to-transparent -translate-x-full rounded-xl"></div>
                  </div>

                  <div className="relative pt-4">
                    <p className="text-5xl sm:text-6xl lg:text-7xl font-extrabold text-white tracking-tighter drop-shadow-lg">
                      CRC
                    </p>
                    {/* Animated underline */}
                    <div className="absolute -bottom-2 left-0 w-full h-2 bg-gradient-to-r from-orange-500 via-yellow-400 to-orange-500 rounded-full animate-pulse"></div>
                  </div>

                  {/* Tagline with badge */}
                  <div className="inline-flex items-center gap-3 bg-white/10 backdrop-blur-sm rounded-full px-6 py-3 border border-white/20 mt-6">
                    <span className="text-lg text-white font-medium">
                      Consumer Rights Council उपभोक्ता अधिकार परिषद्
                    </span>
                    <span className="inline-flex h-6 w-6 items-center justify-center rounded-full bg-orange-500 text-xs font-bold text-white">
                      ✓
                    </span>
                  </div>
                </div>
              </div>
            </div>

            {/* Right: Content Card with Glass Morphism */}
            <div className="relative">
              {/* Floating decorative elements */}
              <div className="absolute -top-6 -left-6 w-24 h-24 bg-orange-400/20 rounded-full blur-xl"></div>
              <div className="absolute -bottom-6 -right-6 w-32 h-32 bg-blue-400/20 rounded-full blur-xl"></div>

              {/* Glass card */}
              <div className="bg-white/10 backdrop-blur-xl rounded-3xl p-6 sm:p-8 lg:p-10 shadow-2xl border border-white/20 relative overflow-hidden">
                {/* Card background pattern */}
                <div className="absolute inset-0 opacity-10">
                  <div
                    className="absolute inset-0"
                    style={{
                      backgroundImage: `url("data:image/svg+xml,%3Csvg width='40' height='40' viewBox='0 0 40 40' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='%23ffffff' fill-opacity='0.4' fill-rule='evenodd'%3E%3Cpath d='M0 40L40 0H20L0 20M40 40V20L20 40'/%3E%3C/g%3E%3C/svg%3E")`,
                    }}
                  ></div>
                </div>

                <div className="relative z-10 space-y-8">
                  {/* Mission header */}
                  <div className="flex items-center gap-4">
                    <div className="w-14 h-14 rounded-full bg-gradient-to-br from-blue-400 to-blue-600 flex items-center justify-center shadow-lg">
                      <div className="w-8 h-8 bg-white rounded-full flex items-center justify-center">
                        <span className="text-blue-600 font-bold text-lg">
                          ✓
                        </span>
                      </div>
                    </div>
                    <div>
                      <h3 className="text-2xl font-bold text-white">
                        Our Mission
                      </h3>
                      <p className="text-blue-100 text-sm">
                        Pan India Presence
                      </p>
                    </div>
                  </div>

                  {/* Content */}
                  <p className="text-lg sm:text-xl text-white leading-relaxed max-w-xl text-center lg:text-left">
                    Consumer Rights Council उपभोक्ता अधिकार परिषद् is a{" "}
                    <span className="font-bold text-blue-200  px-2 py-1 rounded">
                      Registered VCO
                    </span>
                    , operating across India with presence in{" "}
                    <span className="font-bold  px-2 py-1 rounded">
                      12 states and union territories
                    </span>
                    . We collaborate with members and partners on initiatives
                    that create{" "}
                    <span className="font-bold px-2 py-1 rounded">
                      measurable global impact for consumers
                    </span>
                    .
                  </p>

                  {/* Stats with glow effect */}
                  <div className="grid grid-cols-2 gap-6 pt-6">
                    <div className="text-center lg:text-left">
                      <div className="relative">
                        <p className="text-4xl font-bold text-white drop-shadow-lg">
                          12+
                        </p>
                        <p className="text-sm text-blue-200">States & UTs</p>
                        <div className="absolute -inset-2 bg-blue-500/10 blur-md rounded-lg"></div>
                      </div>
                    </div>
                    <div className="text-center lg:text-left">
                      <div className="relative">
                        <p className="text-4xl font-bold text-orange-300 drop-shadow-lg">
                          Pan
                        </p>
                        <p className="text-sm text-orange-200">
                          India Coverage
                        </p>
                        <div className="absolute -inset-2 bg-orange-500/10 blur-md rounded-lg"></div>
                      </div>
                    </div>
                  </div>

                  {/* Action Buttons */}
                  <div className="flex flex-col sm:flex-row gap-4 pt-8 lg:pt-10">
                    <a
                      href="/frequently-asked-questions"
                      className="group flex-1 flex items-center justify-center gap-3 px-8 py-4 bg-gradient-to-r from-blue-600 to-blue-700 text-white rounded-xl hover:from-blue-500 hover:to-blue-600 transition-all duration-300 font-semibold shadow-xl hover:shadow-2xl hover:-translate-y-1 border border-blue-400/30"
                    >
                      <span className="text-lg">Know More</span>
                      <MdArrowOutward className="text-xl group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform duration-300" />
                    </a>

                    <a
                      href="/contactus"
                      className="group flex-1 flex items-center justify-center gap-3 px-8 py-4 bg-white/20 backdrop-blur-sm text-white rounded-xl border-2 border-white/30 hover:bg-white/30 hover:border-white/50 transition-all duration-300 font-semibold shadow-xl hover:shadow-2xl hover:-translate-y-1"
                    >
                      <FaPhone className="text-lg group-hover:animate-pulse" />
                      <span className="text-lg">Get Immediate Help</span>
                    </a>
                  </div>
                </div>
              </div>

              {/* Floating elements */}
              <div className="absolute -top-4 -right-4 w-10 h-10 bg-white/20 rounded-full backdrop-blur-sm border border-white/30"></div>
              <div className="absolute -bottom-4 -left-4 w-8 h-8 bg-orange-400/40 rounded-full backdrop-blur-sm"></div>
            </div>
          </div>

          {/* Bottom decorative line */}
          <div className="hidden lg:block absolute bottom-6 left-1/2 transform -translate-x-1/2 w-48 h-1 bg-gradient-to-r from-transparent via-white/50 to-transparent opacity-40"></div>
        </div>
      </section>

      {/* CTA Section with Interactive Mouse */}
      <section
        className="relative overflow-hidden"
        style={{
          backgroundImage: `url(${HomeCommunityCover})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundAttachment: "fixed",
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-br from-blue-900/70 to-black/60"></div>

        {/* Animated gradient overlay */}
        <div className="absolute inset-0 bg-gradient-to-t from-blue-500/10 via-transparent to-orange-500/10 animate-pulse"></div>

        <Link to="/file-case" className="block relative group">
          <div className="cursor-pointer min-h-[60vh] flex flex-col items-center justify-center text-white text-center px-6 transition-all duration-500 group-hover:bg-black/10">
            {/* Main CTA with enhanced styling */}
            <div className="relative z-10">
              {/* Animated background effect */}
              <div className="absolute inset-0 bg-gradient-to-r from-orange-500/20 to-blue-500/20 blur-2xl rounded-full group-hover:scale-110 transition-transform duration-700"></div>

              <h2 className="text-4xl sm:text-5xl lg:text-6xl font-bold uppercase tracking-wider text-white mb-8 relative">
                <span className="relative z-10 bg-gradient-to-r from-orange-500 to-orange-600 px-10 py-6 rounded-2xl shadow-2xl backdrop-blur-sm border-2 border-orange-300/50 inline-block group-hover:scale-105 group-hover:shadow-orange-500/30 transition-all duration-300">
                  Raise Your Voice
                  {/* Shine effect */}
                  <span className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent -translate-x-full group-hover:translate-x-full transition-transform duration-1000"></span>
                </span>
              </h2>

              {/* Subtitle with enhanced typography */}
              <p className="max-w-2xl text-xl sm:text-2xl text-white/95 leading-relaxed font-semibold mb-12 drop-shadow-lg">
                Speak up, take a stand, and make your voice heard. Together, we
                can bring change and build a stronger community.
              </p>

              {/* Interactive Click Prompt */}
              <div className="mt-12 animate-bounce">
                <div className="flex flex-col items-center gap-4">
                  {/* Animated mouse */}
                  <div className="relative w-14 h-24 border-2 border-white/60 rounded-3xl flex justify-center pt-3 group-hover:border-orange-400 transition-colors duration-300">
                    {/* Mouse wheel */}
                    <div className="w-1 h-3 bg-white/70 rounded-full animate-scroll"></div>
                    {/* Click indicator */}
                    <div className="absolute -bottom-6 w-10 h-10 bg-gradient-to-r from-orange-400 to-orange-500 rounded-full flex items-center justify-center shadow-lg group-hover:scale-110 transition-transform duration-300">
                      <svg
                        className="w-5 h-5 text-white"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="3"
                          d="M14 5l7 7m0 0l-7 7m7-7H3"
                        ></path>
                      </svg>
                    </div>
                  </div>

                  {/* Click text with animation */}
                  <div className="text-white/90 font-medium">
                    <span className="inline-flex items-center gap-2 bg-black/30 px-4 py-2 rounded-lg backdrop-blur-sm">
                      <span className="animate-pulse">Click here</span>
                      <span className="text-orange-300">to file your case</span>
                      <svg
                        className="w-5 h-5 text-orange-300 animate-pulse"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"
                        ></path>
                      </svg>
                    </span>
                  </div>
                </div>
              </div>

              {/* Floating particles */}
              <div className="absolute -top-10 -left-10 w-20 h-20 bg-orange-400/20 rounded-full blur-xl animate-float"></div>
              <div className="absolute -bottom-10 -right-10 w-24 h-24 bg-blue-400/20 rounded-full blur-xl animate-float-delayed"></div>
            </div>
          </div>
        </Link>
      </section>

      {/* About Section - Professional */}
      <section className="relative py-20 bg-gradient-to-b from-white to-blue-50 overflow-hidden">
        {/* Background decorative elements */}
        <div className="absolute inset-0">
          <div className="absolute top-0 left-0 w-72 h-72 bg-blue-100 rounded-full -translate-x-1/2 -translate-y-1/2 opacity-20"></div>
          <div className="absolute bottom-0 right-0 w-96 h-96 bg-indigo-100 rounded-full translate-x-1/3 translate-y-1/3 opacity-20"></div>
          <div className="absolute top-1/2 left-1/4 w-64 h-64 bg-gradient-to-r from-blue-200 to-indigo-200 rounded-full opacity-10"></div>
        </div>

        <div className="relative container mx-auto px-4 sm:px-6 lg:px-8 max-w-7xl">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
            {/* Left: Content */}
            <div className="relative">
              {/* Section label */}
              <div className="mb-8">
                <div className="inline-flex items-center gap-3 mb-4">
                  <div className="w-12 h-1 bg-gradient-to-r from-blue-600 to-indigo-600 rounded-full"></div>
                  <span className="text-sm font-semibold tracking-wider text-blue-600 uppercase">
                    About Our Organization
                  </span>
                </div>

                <h2 className="text-4xl sm:text-5xl font-bold text-gray-900 mb-6">
                  Consumer Rights{" "}
                  <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-600 to-indigo-600">
                    Council of India
                  </span>
                </h2>

                <div className="w-24 h-1 bg-gradient-to-r from-orange-500 to-yellow-500 rounded-full mb-8"></div>
              </div>

              {/* Mission & Vision Cards */}
              <div className="space-y-8">
                {/* Mission Card */}
                <div className="group relative bg-white rounded-2xl p-6 shadow-lg hover:shadow-xl transition-all duration-300 border border-blue-100">
                  <div className="absolute -top-3 -left-3 w-12 h-12 bg-gradient-to-br from-blue-600 to-indigo-600 rounded-xl flex items-center justify-center shadow-lg">
                    <span className="text-white font-bold text-xl">✓</span>
                  </div>

                  <div className="pl-4">
                    <h3 className="text-xl font-bold text-gray-900 mb-3 flex items-center gap-2">
                      <span className="text-blue-600">Our Mission</span>
                      <div className="w-6 h-1 bg-blue-600 rounded-full"></div>
                    </h3>
                    <p className="text-gray-700 leading-relaxed text-lg pl-2 border-l-2 border-blue-100">
                      To establish a{" "}
                      <span className="font-semibold text-blue-700">
                        just, informed, and empowered consumer society
                      </span>{" "}
                      where every individual can exercise their rights with
                      confidence and responsibility.
                    </p>
                  </div>
                </div>

                {/* Vision Card */}
                <div className="group relative bg-white rounded-2xl p-6 shadow-lg hover:shadow-xl transition-all duration-300 border border-indigo-100">
                  <div className="absolute -top-3 -left-3 w-12 h-12 bg-gradient-to-br from-indigo-600 to-purple-600 rounded-xl flex items-center justify-center shadow-lg">
                    <span className="text-white font-bold text-xl">🎯</span>
                  </div>

                  <div className="pl-4">
                    <h3 className="text-xl font-bold text-gray-900 mb-3 flex items-center gap-2">
                      <span className="text-indigo-600">Our Vision</span>
                      <div className="w-6 h-1 bg-indigo-600 rounded-full"></div>
                    </h3>
                    <p className="text-gray-700 leading-relaxed text-lg pl-2 border-l-2 border-indigo-100">
                      To promote{" "}
                      <span className="font-semibold text-indigo-700">
                        consumer education
                      </span>
                      , facilitate{" "}
                      <span className="font-semibold text-indigo-700">
                        legal redressal
                      </span>
                      , and advocate for{" "}
                      <span className="font-semibold text-indigo-700">
                        strong policy measures
                      </span>{" "}
                      that uphold consumer interests and ethical business
                      conduct nationwide.
                    </p>
                  </div>
                </div>
              </div>

              {/* CTA & Stats */}
              <div className="flex flex-col sm:flex-row items-start sm:items-center gap-8 mt-12">
                <a
                  href="/aboutus"
                  className="group relative inline-flex items-center gap-3 px-8 py-4 bg-gradient-to-r from-blue-700 to-blue-800 text-white rounded-xl hover:from-blue-600 hover:to-blue-700 transition-all duration-300 font-semibold shadow-lg hover:shadow-xl hover:-translate-y-1"
                >
                  <span>Learn More About CRC</span>
                  <MdArrowOutward className="text-xl group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform duration-300" />
                  {/* Shimmer effect */}
                  <span className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent -translate-x-full group-hover:translate-x-full transition-transform duration-1000"></span>
                </a>

                {/* Quick Stats */}
                <div className="flex items-center gap-6 text-sm">
                  
                  <div className="h-8 w-px bg-gray-300"></div>
                  <div className="text-center">
                    <div className="text-2xl font-bold text-indigo-700">
                      12+
                    </div>
                    <div className="text-gray-600 font-medium">States</div>
                  </div>
                  <div className="h-8 w-px bg-gray-300"></div>
                  <div className="text-center">
                    <div className="text-2xl font-bold text-blue-700">25K+</div>
                    <div className="text-gray-600 font-medium">Consumers</div>
                  </div>
                </div>
              </div>
            </div>

            {/* Right: Logo/Image with Frame */}
            <div className="relative">
              {/* Decorative frame */}
              <div className="absolute -inset-4 bg-gradient-to-br from-blue-200 via-white to-indigo-200 rounded-3xl opacity-30 blur-xl"></div>

              <div className="relative bg-gradient-to-br from-white to-blue-50 rounded-2xl p-8 shadow-2xl border border-blue-100">
                {/* Certificate-style border */}
                <div className="absolute inset-4 border-2 border-dashed border-blue-200 rounded-xl pointer-events-none"></div>

                {/* Logo Container */}
                <div className="relative p-6 bg-white rounded-xl shadow-inner">
                  {/* Corner decorations */}
                  <div className="absolute top-0 left-0 w-8 h-8 border-t-2 border-l-2 border-blue-400 rounded-tl-lg"></div>
                  <div className="absolute top-0 right-0 w-8 h-8 border-t-2 border-r-2 border-blue-400 rounded-tr-lg"></div>
                  <div className="absolute bottom-0 left-0 w-8 h-8 border-b-2 border-l-2 border-blue-400 rounded-bl-lg"></div>
                  <div className="absolute bottom-0 right-0 w-8 h-8 border-b-2 border-r-2 border-blue-400 rounded-br-lg"></div>

                  {/* Logo */}
                  <div className="flex flex-col items-center justify-center">
                    <img
                      src={CSDLogoAbout}
                      alt="Consumer Rights Council India - Registered VCO"
                      loading="lazy"
                      className="w-full max-w-md h-auto"
                      width={500}
                      height={400}
                    />

                    {/* Logo caption */}
                    <div className="mt-8 text-center">
                      <div className="inline-flex items-center gap-2 px-4 py-2 bg-gradient-to-r from-blue-50 to-indigo-50 rounded-lg border border-blue-100">
                        <span className="text-sm font-semibold text-blue-700">
                          Registered Volunteer Consumer Organization
                        </span>
                        <span className="text-blue-600 font-bold">✓</span>
                      </div>
                      <p className="text-gray-600 text-sm mt-3">
                        Recognized nationwide for consumer advocacy.
                      </p>
                    </div>
                  </div>
                </div>

                {/* Accreditation badges */}
                <div className="flex flex-wrap gap-4 justify-center mt-8">
                  <div className="flex items-center gap-2 bg-white px-4 py-2 rounded-lg border border-green-100 shadow-sm">
                    <div className="w-3 h-3 bg-green-500 rounded-full"></div>
                    <span className="text-sm font-medium text-gray-700">
                      Govt. Recognized
                    </span>
                  </div>
                  <div className="flex items-center gap-2 bg-white px-4 py-2 rounded-lg border border-blue-100 shadow-sm">
                    <div className="w-3 h-3 bg-blue-500 rounded-full"></div>
                    <span className="text-sm font-medium text-gray-700">
                      Pan India
                    </span>
                  </div>
                  <div className="flex items-center gap-2 bg-white px-4 py-2 rounded-lg border border-orange-100 shadow-sm">
                    <div className="w-3 h-3 bg-orange-500 rounded-full"></div>
                    <span className="text-sm font-medium text-gray-700">
                      ISO Certified
                    </span>
                  </div>
                </div>
              </div>

              {/* Floating element */}
              <div className="absolute -bottom-4 -right-4 w-16 h-16 bg-gradient-to-br from-blue-500 to-indigo-500 rounded-full flex items-center justify-center shadow-xl">
                <span className="text-white font-bold">VCO</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Engagement & Testimonials */}
      <LineofEngagement />
      <Testimonials />
    </section>
  );
};

export default HomeTitle;
